module.exports = __webpack_public_path__ + "img/389.cd29aab7.png";